export default __webpack_public_path__ + "static/RTG_PDP_LOGO_BEDGEAR_585x100-f466fb36b9caebd7d3f47f10e3f80862.png";